import {Injectable} from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Observable } from 'rxjs';

import {  throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AuthorizationService } from "../authorization/authorization.service";

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {

 private guestUrls = [
    'services/content/',
    'security/authenticate',
    'login/login',
    '/login/emailVerificationForLogin',
    'registration/',
    'guestpay/',
    'paynow/PayToggle',
    '/admin/',
    '/dynamiclease/getCounties',
    '/dynamiclease/getStates',
    'ccpa/',
    'util/calculator',
    'resetPassword/',
    'login/forgotUserId',
    'interestletter/adminretrieveInterestLetter',
    'errorlog/'
  ];

  constructor(
    private authService: AuthorizationService,
    private tokenExtractor: HttpXsrfTokenExtractor
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // ✅ Skip guest endpoints entirely
    if (this.isGuestUrl(req.url)) {
      return next.handle(req);
    }

    const token = sessionStorage.getItem('Authorization');
    const userId = sessionStorage.getItem('userId');
    const csrfToken = this.tokenExtractor.getToken();

    if (csrfToken) {
      req = req.clone({
        setHeaders: { 'X-XSRF-TOKEN': csrfToken }
      });
    }

    // ✅ Attach token only if it exists
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          userId: userId ?? ''
        }
      });
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        // 🚫 DO NOT refresh token for guests
        if (!token) {
          return throwError(() => error);
        }

        // ✅ Token refresh only for authenticated users
        if (error.status === 401) {
          return this.authService.getAuthToken().pipe(
            mergeMap((authDetails: any) => {
              if (authDetails?.token) {
                sessionStorage.setItem('Authorization', authDetails.token);
                sessionStorage.setItem('userId', authDetails.userId);

                const retryReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${authDetails.token}`,
                    userId: authDetails.userId
                  }
                });

                return next.handle(retryReq);
              }

              return throwError(() => error);
            })
          );
        }

        return throwError(() => error);
      })
    );
  }

  private isGuestUrl(url: string): boolean {
    return this.guestUrls.some(g => url.includes(g));
  }
}

/*  */